import {RouteRecordRaw} from 'vue-router';

export default function (rootName: string): RouteRecordRaw[] {
    return [
        {
            path: `orders-filter`,
            name: `${rootName}OrdersFilter`,
            component: () => import('../../planning-tool/components/orders-panel/components/OrderFilterForm.vue'),
            props: (route) => {
                return Object.assign({
                    backRouteName: rootName
                });
            }
        }
    ];
}
